var SUPPORTED_PLATFORMS = {
  youtube: "youtube",
  vimeo: "vimeo",
  instagram: "instagram"
};
export {
  SUPPORTED_PLATFORMS
};
